import { createLogger } from '@/lib/logger'
import type { User } from '@/payload-types'

const logger = createLogger('FetchCurrentUser')

let cached: Promise<User | null> | null = null

// Client-side current-user lookup via Payload's /api/users/me. The AuthjsStrategy
// registered on the Users collection authenticates the Auth.js session cookie, so
// this returns the Payload user for logged-in visitors and null for everyone else
// (the proxy's payloadApiGuard 401s anonymous requests before they hit Payload).
// Cached per page load — call with { refresh: true } after a login completes in
// the same document (OAuth/magic-link returns are full navigations, so the cache
// resets naturally there).
export function fetchCurrentUser(options: { refresh?: boolean } = {}): Promise<User | null> {
  if (!cached || options.refresh) {
    cached = (async (): Promise<User | null> => {
      try {
        const response = await fetch('/api/users/me', { credentials: 'include' })
        if (!response.ok) return null
        const data = (await response.json()) as { user?: User | null }
        return data?.user ?? null
      } catch (error) {
        logger.warn('Failed to fetch current user', error)
        return null
      }
    })()
  }
  return cached
}
